// extracted by mini-css-extract-plugin
export default {"column":"BK4LmyaoSD3NS6FApZgf","row":"VzTYQ3VLojiIW_mYh2WL"};